/**
 * API host for both websites.
 *
 * The page may be on tasky.do or curedia.com. The API is always the
 * Taskydo host for that organisation, because there is one Django
 * project. Local dev stays on the page origin so the Vite proxy works.
 */

function normalise(value) {
  return String(value || '').toLowerCase().trim().replace(/^\.+/, '');
}

function isLocal(host, taskydoDomain) {
  return (
    host === 'localhost'
    || host === '127.0.0.1'
    || host.endsWith('.localhost')
    || taskydoDomain === 'localhost'
    || taskydoDomain.endsWith('.localhost')
  );
}

function onApex(host, apex) {
  return host === apex || host === `www.${apex}` || host.endsWith(`.${apex}`);
}

function slugOf(host, apex) {
  if (host === apex || host === `www.${apex}`) return '';
  if (!host.endsWith(`.${apex}`)) return '';
  const rest = host.slice(0, -(apex.length + 1));
  return rest.split('.').filter(Boolean)[0] || '';
}

export function apiOriginFromLocation(location, domains) {
  const taskydoDomain = normalise(domains && domains.taskydoDomain) || 'tasky.do';
  const curediaDomain = normalise(domains && domains.curediaDomain) || 'curedia.com';
  const host = normalise(location && location.hostname);
  const pageHost = location && location.host ? location.host : host;
  const protocol = (location && location.protocol) || 'https:';
  const pageOrigin = `${protocol}//${pageHost}`;
  if (!host || isLocal(host, taskydoDomain)) return pageOrigin;
  if (onApex(host, curediaDomain)) {
    const slug = slugOf(host, curediaDomain);
    const apiHost = slug ? `${slug}.${taskydoDomain}` : taskydoDomain;
    return `https://${apiHost}`;
  }
  return pageOrigin;
}
